import * as React from 'react';
import CircleChevronGray from '../../../assets/icons/CircleChevronGray.esm.js';
import classNames from 'classnames';
import { ButtonBack } from 'pure-react-carousel';
import styles from '../CarouselButtons.module.esm.js';

var CarouselButtonBack = function () {
    return (React.createElement(ButtonBack, { className: classNames(styles.buttonBack, styles.carouselButton) },
        React.createElement(CircleChevronGray, { className: styles.circleChevron })));
};

export { CarouselButtonBack };
//# sourceMappingURL=CarouselButtonBack.esm.js.map
